/**
 * Author: Claude Code
 * Version: v3.2.17
 * Modified: 2025-10-03
 *
 * PlayerLeaderboard - 玩家表现排行榜（参考page.tsx）
 */

import React from 'react';

export interface PlayerStats {
  name: string;
  totalReturn: number;
  winRate: number;
  gamesPlayed: number;
  profit: number;
}

export interface PlayerLeaderboardProps {
  isVisible: boolean;
  onClose?: () => void;
}

const mockPlayerLeaderboard: PlayerStats[] = [
  { name: 'PlayerName', totalReturn: 12500, winRate: 68, gamesPlayed: 25, profit: 8200 },
  { name: 'AlphaGamer', totalReturn: 9800, winRate: 72, gamesPlayed: 18, profit: 6400 },
  { name: 'BetMaster', totalReturn: 8600, winRate: 45, gamesPlayed: 32, profit: -1200 },
  { name: 'LuckyStrike', totalReturn: 7200, winRate: 89, gamesPlayed: 9, profit: 5800 },
  { name: 'RiskTaker', totalReturn: 6500, winRate: 38, gamesPlayed: 28, profit: -2100 }
];

export const PlayerLeaderboard: React.FC<PlayerLeaderboardProps> = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  const sortedPlayers = [...mockPlayerLeaderboard].sort((a, b) => b.profit - a.profit);

  return (
    <div className="expanded-panel leaderboard-panel">
      <div className="panel-header">
        <h3>🏆 Player Performance</h3>
        {onClose && (
          <button className="close-btn" onClick={onClose}>✕</button>
        )}
      </div>
      <div className="panel-body">
        <div className="leaderboard-header-row">
          <span className="col-rank">Rank</span>
          <span className="col-player">Player</span>
          <span className="col-winrate">Win Rate</span>
          <span className="col-games">Games</span>
          <span className="col-profit">Profit</span>
        </div>
        <div className="leaderboard-rows">
          {sortedPlayers.map((player, i) => (
            <div key={player.name} className="leaderboard-row">
              <span className="col-rank">#{i + 1}</span>
              <span className={`col-player ${player.name === 'PlayerName' ? 'you' : ''}`}>
                {player.name === 'PlayerName' ? 'You' : player.name}
              </span>
              <span className={`col-winrate ${
                player.winRate >= 60 ? 'high' : player.winRate >= 40 ? 'medium' : 'low'
              }`}>
                {player.winRate}%
              </span>
              <span className="col-games">{player.gamesPlayed}</span>
              <span className={`col-profit ${player.profit >= 0 ? 'positive' : 'negative'}`}>
                {player.profit >= 0 ? '+' : ''}{player.profit.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
        <div className="leaderboard-summary">
          <div className="summary-row">
            <span>Your Total Return:</span>
            <span className="value">{sortedPlayers[0].totalReturn.toLocaleString()} momo</span>
          </div>
          <div className="summary-row">
            <span>Your Win Rate:</span>
            <span className="value positive">{sortedPlayers[0].winRate}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};
